import React, { useState } from "react";
import Row from "@amzn/meridian/row";
import { FormattedMessage } from "react-intl";
import scanPhoto from "../../badge_image.png";
import Alert from "@amzn/meridian/alert";
import Box from "@amzn/meridian/box";
import ScanBarcode from "../../../scanBarcode/scanBarcode";

function BadgeScanOption({ setAlias, onGenerateQRCode, tokenValue }) {
  const [scanError, setScanError] = useState(false);
  const handleScanResponse = (error, alias) => {
    alias = alias.toLowerCase();
    if (!error) {
      onGenerateQRCode(alias, () => {
        if (!tokenValue) {
          setScanError(true);
        }
      });
      setAlias(alias);
    } else {
      setScanError(error);
    }
  };
  return (
    <Box
      width="100%"
      height="100%"
      type="outline"
      spacing="1000"
      backgroundColor="#E9EBEF"
      spacingInset="400"
    >
      <Row>
        <Alert size="small" type="informational">
          <strong>
            <FormattedMessage
              id="verificationOptions.text.badgeScan"
              defaultMessage="Scan associate's badge"
            />
          </strong>
        </Alert>
      </Row>
      <Row spacingInset={"100 none none 450"}>
        <p
          style={{
            fontSize: "14px",
          }}
        >
          <FormattedMessage
            id="verificationOptions.text.subHeading"
            defaultMessage="Verification will be valid until the end of your shift or until associate logout."
          />
        </p>
      </Row>
      <Row>
        <ScanBarcode image={scanPhoto} onScanResponse={handleScanResponse} />
      </Row>
      <Row>
        {scanError && (
          <Alert size="small" type="error">
            <FormattedMessage
              id="verificationOptions.text.error"
              defaultMessage="Associate not found. Confirm credentials and enter again."
            />
          </Alert>
        )}
      </Row>
    </Box>
  );
}

export default BadgeScanOption;



// WEBPACK FOOTER //
// ./src/components/dolphinVerification/verificationWindow/verificationOptions/BadgeScan.js